/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BuildingDto { 
    uuid?: string;
    name?: string;
    names?: { [key: string]: string; };
    descriptions?: { [key: string]: string; };
    limited?: boolean;
    cost?: number;
    trade?: number;
    production?: number;
    culture?: number;
    coins?: number;
    combatBonuses?: number;
    upgraded?: boolean;
    upgradedBuilding?: string;
    allowedTerrain?: BuildingDto.AllowedTerrainEnum;
    forbiddenTerrain?: BuildingDto.ForbiddenTerrainEnum;
}
export namespace BuildingDto {
    export type AllowedTerrainEnum = 'Mountain' | 'Forest' | 'Grassland' | 'Desert' | 'Water';
    export const AllowedTerrainEnum = {
        Mountain: 'Mountain' as AllowedTerrainEnum,
        Forest: 'Forest' as AllowedTerrainEnum,
        Grassland: 'Grassland' as AllowedTerrainEnum,
        Desert: 'Desert' as AllowedTerrainEnum,
        Water: 'Water' as AllowedTerrainEnum
    };
    export type ForbiddenTerrainEnum = 'Mountain' | 'Forest' | 'Grassland' | 'Desert' | 'Water';
    export const ForbiddenTerrainEnum = {
        Mountain: 'Mountain' as ForbiddenTerrainEnum,
        Forest: 'Forest' as ForbiddenTerrainEnum,
        Grassland: 'Grassland' as ForbiddenTerrainEnum,
        Desert: 'Desert' as ForbiddenTerrainEnum,
        Water: 'Water' as ForbiddenTerrainEnum
    };
}